export const SHOW_DELETE_STORE_MODAL = 'SHOW_DELETE_STORE_MODAL';
export const DELETE_STORE = 'DELETE_STORE';
